var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66667C12 11.3333 6 15.3333 6 15.3333C6 15.3333 0 11.3333 0 6.66667C2.37122e-08 5.07537 0.632141 3.54925 1.75736 2.42403C2.88258 1.29881 4.4087 0.666672 6 0.666672C7.5913 0.666672 9.11742 1.29881 10.2426 2.42403C11.3679 3.54925 12 5.07537 12 6.66667Z",
    fill: "#290E41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.66667C7.10457 8.66667 8 7.77124 8 6.66667C8 5.5621 7.10457 4.66667 6 4.66667C4.89543 4.66667 4 5.5621 4 6.66667C4 7.77124 4.89543 8.66667 6 8.66667Z",
    fill: "#F9F9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointer);
export default __webpack_public_path__ + "static/media/location-pointer.d43a232862a68b8fd6d1ab61c68e2594.svg";
export { ForwardRef as ReactComponent };